module.exports = __webpack_public_path__ + "img/2.4b267f5b.png";